/**
 * Breakpoints
 *
 * @example
 * ```tsx
 * <div css={{
 *   [Breakpoints.smallDeviceAndUp]: {
 *     display: "block",
 *   },
 *   [Breakpoints.mediumDeviceAndUp]: {
 *     display: "block",
 *   },
 * }}>
 */
export const Breakpoints = {
  // Small Device and Up
  smallDeviceAndUp: "@media (min-width: 415px)",
  // Medium Device and Up
  mediumDeviceAndUp: "@media (min-width: 900px)",
};
